import SiteNavbar from "@/components/SiteNavbar";
import { SiLine } from "react-icons/si";
import { Shield, Zap, Droplets, Eye } from "lucide-react";

const BOTTLES = "https://skyagent-artifacts.skywork.ai/router/agent/2026-06-16/prod_agent_317c2af3-f3bf-4d1a-aeff-3678ee16544c/S__36929553_c986793f45cf46a7a917d1e3441b0785.jpg";

const products = [
  {
    id: "hyper-wax",
    name: "HYPER WAX",
    volume: "250ml",
    icon: <Zap size={28} color="#E8212A" />,
    feature: {
      label: "Feature",
      color: "#E8212A",
      text: "สูตร Liquid Ceramic ผสม SiO₂ + Multi-Complex Wax ใช้ง่ายแค่ 'ฉีดแล้วเช็ด' ไม่ต้องขัดสี",
    },
    advantage: {
      label: "Advantage",
      color: "#f59e0b",
      text: "สร้างชั้น Ceramic Film ปกป้องสีรถจากฝุ่น UV และมลภาวะ ให้ความเงาระดับ Showroom",
    },
    benefit: {
      label: "Benefit",
      color: "#4ade80",
      text: "รถสวยเงาได้ใน 3 นาที ล้างรถง่ายขึ้น ฝุ่นและน้ำไม่เกาะสีรถ ประหยัดค่าเคลือบแก้วราคาสูง",
    },
    badge: "Best Seller",
  },
  {
    id: "hyper-gel",
    name: "HYPER GEL Tyre 'n' Rubber",
    volume: "250ml",
    icon: <Droplets size={28} color="#E8212A" />,
    feature: {
      label: "Feature",
      color: "#E8212A",
      text: "เจลสูตร Hydrophobic พิเศษ Non-sticky ใช้ได้ทั้งยางรถและชิ้นส่วนยาง/พลาสติกสีดำ",
    },
    advantage: {
      label: "Advantage",
      color: "#f59e0b",
      text: "ฟื้นฟูความเงาของยางและขอบยางได้ทันทีหลังใช้ ป้องกันการซีดจากแดดและโอโซน",
    },
    benefit: {
      label: "Benefit",
      color: "#4ade80",
      text: "ยางดูใหม่ สีดำเข้มขลัง รถดูหมดจดเสมอ ไม่เหนียวเลอะมือ ทนนานกว่าสเปรย์ทั่วไป",
    },
    badge: "Tyre Care",
  },
  {
    id: "leather-emulsion",
    name: "LEATHER EMULSION Intensive Conditioner",
    volume: "250ml",
    icon: <Shield size={28} color="#E8212A" />,
    feature: {
      label: "Feature",
      color: "#E8212A",
      text: "สูตร Intensive Emulsion + Multi-Complex Wax ฉีดแล้วเช็ด ใช้ได้ทั้งเบาะหนัง พวงมาลัย แผงประตู และเฟอร์นิเจอร์หนัง",
    },
    advantage: {
      label: "Advantage",
      color: "#f59e0b",
      text: "บำรุงและฟื้นฟูหนังอย่างเข้มข้น ป้องกันการแตกแห้ง คืนความนุ่มและความเงาให้หนัง",
    },
    benefit: {
      label: "Benefit",
      color: "#4ade80",
      text: "ห้องโดยสารดูหรูหรา กลิ่นหนังใหม่ ยืดอายุเบาะหนังได้นาน ประหยัดค่าซ่อมและเปลี่ยนเบาะ",
    },
    badge: "Interior Care",
  },
  {
    id: "rain-shield",
    name: "RAIN SHIELD Water Repellent",
    volume: "100ml",
    icon: <Eye size={28} color="#E8212A" />,
    feature: {
      label: "Feature",
      color: "#E8212A",
      text: "Hydrophobic Coating สูตรพิเศษ ใช้ได้กับกระจกทุกชนิด ทั้งกระจกหน้า กระจกข้าง กระจกมองหลัง",
    },
    advantage: {
      label: "Advantage",
      color: "#f59e0b",
      text: "สร้างชั้นฟิล์ม Hydrophobic ทำให้น้ำเกาะเป็นหยดกลิ้งออก มองเห็นชัดในสภาวะฝนตกหนัก",
    },
    benefit: {
      label: "Benefit",
      color: "#4ade80",
      text: "ขับปลอดภัยมากขึ้นในหน้าฝน ลดการเปิดที่ปัดน้ำฝน ทัศนวิสัยดีขึ้น 70% ป้องกันคราบน้ำ",
    },
    badge: "Safety",
  },
];

const Index = () => {
  return (
    <div style={{ background: "#0D0D0D", minHeight: "100vh", fontFamily: "Rajdhani, sans-serif" }}>
      <SiteNavbar currentPage="/#/car-detailing" />

      {/* Hero */}
      <section
        style={{
          position: "relative",
          minHeight: "60vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
          paddingTop: "64px",
        }}
      >
        <div
          style={{
            position: "absolute",
            inset: 0,
            backgroundImage: `url(${BOTTLES})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            filter: "brightness(0.35)",
          }}
        />
        <div
          style={{
            position: "absolute",
            inset: 0,
            background: "linear-gradient(to bottom, rgba(13,13,13,0.5) 0%, rgba(13,13,13,0.8) 100%)",
          }}
        />
        <div style={{ position: "relative", zIndex: 2, textAlign: "center", padding: "80px 20px" }}>
          <p
            style={{
              color: "#E8212A",
              fontSize: "13px",
              letterSpacing: "0.3em",
              textTransform: "uppercase",
              fontWeight: 700,
              marginBottom: "16px",
            }}
          >
            ENZO Car Care Series
          </p>
          <h1
            style={{
              fontFamily: "Rajdhani, sans-serif",
              fontSize: "clamp(36px, 7vw, 80px)",
              fontWeight: 700,
              color: "#fff",
              lineHeight: 1.05,
              letterSpacing: "-0.01em",
              marginBottom: "20px",
              textShadow: "0 4px 40px rgba(0,0,0,0.8)",
            }}
          >
            ENZO <span style={{ color: "#E8212A" }}>CAR CARE</span> SERIES
          </h1>
          <p
            style={{
              fontFamily: "Sarabun, sans-serif",
              fontSize: "clamp(15px, 2.5vw, 20px)",
              color: "rgba(255,255,255,0.75)",
              maxWidth: "560px",
              margin: "0 auto",
              lineHeight: 1.7,
            }}
          >
            ผลิตภัณฑ์ดูแลรถยนต์คุณภาพพรีเมียม ปกป้องสีรถ ฟื้นฟูยาง บำรุงหนัง และเพิ่มทัศนวิสัยในทุกสภาพอากาศ
          </p>
        </div>
      </section>

      {/* Products Grid */}
      <section style={{ padding: "80px 0" }}>
        <div className="container mx-auto px-4">
          <div
            style={{
              textAlign: "center",
              marginBottom: "60px",
            }}
          >
            <h2
              style={{
                fontFamily: "Rajdhani, sans-serif",
                fontSize: "clamp(28px, 5vw, 48px)",
                fontWeight: 700,
                color: "#fff",
                lineHeight: 1.1,
              }}
            >
              PRODUCT <span style={{ color: "#E8212A" }}>LINE-UP</span>
            </h2>
            <p
              style={{
                fontFamily: "Sarabun, sans-serif",
                fontSize: "15px",
                color: "rgba(255,255,255,0.5)",
                marginTop: "12px",
              }}
            >
              แต่ละผลิตภัณฑ์ออกแบบมาเพื่อแก้ปัญหาเฉพาะด้าน ใช้ง่าย ได้ผลจริง
            </p>
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
              gap: "28px",
            }}
          >
            {products.map((p) => (
              <div
                key={p.id}
                style={{
                  background: "#161616",
                  border: "1px solid rgba(255,255,255,0.08)",
                  borderRadius: "6px",
                  overflow: "hidden",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {/* Card header */}
                <div
                  style={{
                    background: "linear-gradient(135deg, #1a1a1a 0%, #222 100%)",
                    padding: "24px",
                    borderBottom: "1px solid rgba(232,33,42,0.2)",
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "16px",
                  }}
                >
                  <div
                    style={{
                      width: "52px",
                      height: "52px",
                      background: "rgba(232,33,42,0.1)",
                      border: "1px solid rgba(232,33,42,0.3)",
                      borderRadius: "8px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >
                    {p.icon}
                  </div>
                  <div style={{ flex: 1 }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px", flexWrap: "wrap", marginBottom: "4px" }}>
                      <span
                        style={{
                          padding: "2px 8px",
                          background: "#E8212A",
                          color: "#fff",
                          fontSize: "10px",
                          fontWeight: 700,
                          letterSpacing: "0.08em",
                          borderRadius: "2px",
                          fontFamily: "Rajdhani, sans-serif",
                        }}
                      >
                        {p.badge}
                      </span>
                      <span
                        style={{
                          padding: "2px 8px",
                          background: "rgba(255,255,255,0.08)",
                          color: "rgba(255,255,255,0.5)",
                          fontSize: "10px",
                          fontWeight: 600,
                          borderRadius: "2px",
                          fontFamily: "Rajdhani, sans-serif",
                        }}
                      >
                        {p.volume}
                      </span>
                    </div>
                    <h3
                      style={{
                        fontFamily: "Rajdhani, sans-serif",
                        fontSize: "20px",
                        fontWeight: 700,
                        color: "#fff",
                        lineHeight: 1.2,
                        margin: 0,
                      }}
                    >
                      {p.name}
                    </h3>
                  </div>
                </div>

                {/* FAB Sections */}
                <div style={{ padding: "20px", flex: 1, display: "flex", flexDirection: "column", gap: "16px" }}>
                  {[p.feature, p.advantage, p.benefit].map((item) => (
                    <div
                      key={item.label}
                      style={{
                        background: "rgba(255,255,255,0.03)",
                        border: `1px solid ${item.color}30`,
                        borderLeft: `3px solid ${item.color}`,
                        borderRadius: "4px",
                        padding: "14px 16px",
                      }}
                    >
                      <p
                        style={{
                          fontFamily: "Rajdhani, sans-serif",
                          fontSize: "11px",
                          fontWeight: 700,
                          color: item.color,
                          letterSpacing: "0.2em",
                          textTransform: "uppercase",
                          marginBottom: "6px",
                        }}
                      >
                        {item.label}
                      </p>
                      <p
                        style={{
                          fontFamily: "Sarabun, sans-serif",
                          fontSize: "14px",
                          color: "rgba(255,255,255,0.75)",
                          lineHeight: 1.6,
                          margin: 0,
                        }}
                      >
                        {item.text}
                      </p>
                    </div>
                  ))}
                </div>

                {/* CTA */}
                <div style={{ padding: "16px 20px", borderTop: "1px solid rgba(255,255,255,0.06)" }}>
                  <a
                    href="https://lin.ee/usuFQKq"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "8px",
                      padding: "12px",
                      background: "#06C755",
                      color: "#fff",
                      textDecoration: "none",
                      fontFamily: "Rajdhani, sans-serif",
                      fontWeight: 700,
                      fontSize: "14px",
                      letterSpacing: "0.06em",
                      borderRadius: "4px",
                      transition: "background 0.2s",
                    }}
                    onMouseEnter={(e: React.MouseEvent<HTMLAnchorElement>) => {
                      (e.currentTarget as HTMLAnchorElement).style.background = "#04a344";
                    }}
                    onMouseLeave={(e: React.MouseEvent<HTMLAnchorElement>) => {
                      (e.currentTarget as HTMLAnchorElement).style.background = "#06C755";
                    }}
                  >
                    <SiLine size={16} /> สอบถามสินค้า
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Bottom CTA */}
      <section
        style={{
          background: "#111",
          borderTop: "1px solid rgba(232,33,42,0.2)",
          padding: "60px 0",
          textAlign: "center",
        }}
      >
        <div className="container mx-auto px-4">
          <h2
            style={{
              fontFamily: "Rajdhani, sans-serif",
              fontSize: "clamp(24px, 4vw, 40px)",
              fontWeight: 700,
              color: "#fff",
              marginBottom: "16px",
            }}
          >
            สอบถามและ<span style={{ color: "#E8212A" }}>สั่งซื้อสินค้า</span>
          </h2>
          <p
            style={{
              fontFamily: "Sarabun, sans-serif",
              fontSize: "16px",
              color: "rgba(255,255,255,0.6)",
              marginBottom: "32px",
            }}
          >
            ทักมาได้เลย — ทีมงานยินดีให้คำแนะนำผลิตภัณฑ์ที่เหมาะกับรถของคุณ
          </p>
          <a
            href="https://lin.ee/usuFQKq"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "10px",
              padding: "14px 36px",
              background: "#06C755",
              color: "#fff",
              textDecoration: "none",
              fontFamily: "Rajdhani, sans-serif",
              fontWeight: 700,
              fontSize: "16px",
              letterSpacing: "0.08em",
              textTransform: "uppercase",
              borderRadius: "4px",
            }}
          >
            <SiLine size={20} /> LINE สอบถามสินค้า
          </a>
        </div>
      </section>
    </div>
  );
};

export default Index;
